import styled from 'styled-components';
export var AspectRatioWrapper = styled.div.withConfig({
  displayName: "partials__AspectRatioWrapper",
  componentId: "sc-an0mac-0"
})(["position:relative;width:100%;height:0;padding-bottom:56.25%;iframe{position:absolute;top:0;left:0;width:100%;height:100%;border:none;border-radius:8px;}"]);